// Pure geometry for the CapabilityWeb connectors. No DOM — the measured hub and
// card coordinates are passed in, and an SVG path string comes out.

export interface ConnectorLine {
  d: string;
}

// The inner "card within a card" — a white tile floating on the tinted card.
// Shared by every CapabilityWeb case visual.
export const CAPABILITY_PANEL =
  "mt-auto rounded-2xl border border-black/5 bg-white p-3 pt-4";

// The connector from the hub (hx,hy) to a card edge (cx,cy), shaped like the
// reference: a SHORT horizontal trunk out of the hub, a fork near the hub, then
// each branch runs out to its own horizontal lane and rises/drops into its card.
// The two cards in a side column share hub, trunk and fork x, so their trunks
// overlap and split at the same point — the merge. A card directly above/below
// the hub gets a plain vertical.
export const elbow = (hx: number, hy: number, cx: number, cy: number) => {
  const dx = cx - hx;
  const dy = cy - hy;
  if (Math.abs(dx) < 2) return `M ${hx} ${hy} L ${cx} ${cy}`;
  const sx = Math.sign(dx);
  const sy = Math.sign(dy);
  const trunk = Math.min(64, Math.abs(dx) * 0.28);
  const jx = hx + sx * trunk;
  const ly = (hy + cy) / 2;
  const r = Math.max(4, Math.min(14, trunk - 1, Math.abs(hy - ly) - 1));
  return [
    `M ${hx} ${hy}`,
    `L ${jx - sx * r} ${hy}`,
    `Q ${jx} ${hy} ${jx} ${hy + sy * r}`,
    `L ${jx} ${ly - sy * r}`,
    `Q ${jx} ${ly} ${jx + sx * r} ${ly}`,
    `L ${cx - sx * r} ${ly}`,
    `Q ${cx} ${ly} ${cx} ${ly + sy * r}`,
    `L ${cx} ${cy}`,
  ].join(" ");
};
